import { createBrowserRouter, Navigate } from 'react-router';
import { RouteLayout } from '../components/RouteLayout';
import { WelcomePage } from './welcome/WelcomePage';
import { MenuPage } from './menu/MenuPage';
import { HeroesPage } from './gallery/HeroesPage';
import { MinionsPage } from './gallery/MinionsPage';
import { PlayPage } from './play/PlayPage';
import { ProfilePage } from './profile/ProfilePage';
import { ShopPage } from './shop/ShopPage';
import { ChangesPage } from './changes/ChangesPage';
import { SettingsPage } from './settings/SettingsPage';
import { LadderPage } from './ladder/LadderPage';
import { MatchesPage } from './matches/MatchesPage';
import { FriendsPage } from './friends/FriendsPage';
import { SplashPage } from './splash/SplashPage';
import { HeroSelectPage } from './game/heroSelect/HeroSelectPage';
import { DraftPage } from './game/draft/DraftPage';
import { TavernPage } from './game/tavern/TavernPage';
import { CombatPage } from './game/combat/CombatPage';
import { ResultsPage } from './game/results/ResultsPage';

// Vite's BASE_URL ends with '/'. Strip for React Router's basename contract.
const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';

export const router = createBrowserRouter(
  [
    {
      element: <RouteLayout />,
      children: [
        { index: true, element: <SplashPage /> },
        { path: 'welcome', element: <WelcomePage /> },
        { path: 'menu', element: <MenuPage /> },
        { path: 'play', element: <PlayPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'shop', element: <ShopPage /> },
        { path: 'settings', element: <SettingsPage /> },
        { path: 'changes', element: <ChangesPage /> },
        { path: 'heroes', element: <HeroesPage /> },
        { path: 'minions', element: <MinionsPage /> },
        { path: 'ladder', element: <LadderPage /> },
        { path: 'matches', element: <MatchesPage /> },
        { path: 'friends', element: <FriendsPage /> },
        { path: 'game/:matchId/hero', element: <HeroSelectPage /> },
        { path: 'game/:matchId/draft', element: <DraftPage /> },
        { path: 'game/:matchId/tavern', element: <TavernPage /> },
        { path: 'game/:matchId/combat', element: <CombatPage /> },
        { path: 'game/:matchId/results', element: <ResultsPage /> },
        { path: '*', element: <Navigate to="/" replace /> },
      ],
    },
  ],
  { basename },
);
